import { render, staticRenderFns } from "./SetFrprint.vue?vue&type=template&id=3fd45e74&scoped=true&"
import script from "./SetFrprint.vue?vue&type=script&lang=js&"
export * from "./SetFrprint.vue?vue&type=script&lang=js&"
import style0 from "./SetFrprint.vue?vue&type=style&index=0&id=3fd45e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd45e74",
  null
  
)

export default component.exports